import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Chooser } from '@ionic-native/chooser/ngx';

@Injectable({
    providedIn: 'root'
})
export class FileService {

    public constructor(private chooser: Chooser,
        private platform: Platform) { }

    public ifMobile() {
        return !this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios'));
    }

    public async chooseFile(accept = ''): Promise<File> {
        if (this.ifMobile()) {
            const chooserResult = await this.chooser.getFile(accept);

            if (chooserResult && chooserResult.dataURI && chooserResult.name) {
                const response = await fetch(chooserResult.dataURI);
                const blob = await response.blob();
                const file = new File([blob], chooserResult.name, { type: chooserResult.mediaType });

                return file;
            }

            throw new Error('Failed to convert ChooserResult to File');
        }
    }
}
